import { Component, OnInit, Input, Pipe, PipeTransform, ViewChild, QueryList, ViewChildren } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { UserService } from '../_services';
import { User } from '../user/user';
import { Authenticate } from '../authenticate/authenticate';
import {ClientService} from './clientservice';
import { Client } from './client';
import * as XLSX from 'xlsx';


@Component({
  selector: 'app-client',
  templateUrl: './client.component.html',
  styleUrls: ['./client.component.less',  '../app.component.less']
})
export class ClientComponent implements OnInit {

  clients: Client[];
  currentuser : User;
  auth : Authenticate; 
  querycriteria : string;
  searchquery : string ; 
  showId = true;
  showName = true;
  showContactName = true;
  showAddress = true;
  showPhoneNumber = true;
  showEmail = true;
  title = 'angular-app';
  fileName= 'Clients Export.xlsx';
  isLoading = false; 
  

  constructor(private http: HttpClient,
    private clientservice: ClientService,
    private userservice: UserService
    )
     { }
  private userrole: string;

//------------------------------------------------------------
//  PAGE LOAD FUNCTION
//------------------------------------------------------------
  ngOnInit() {

    console.log("we entered INIT FUNCTION");
   // this.isLoading = true;
    this.currentuser = this.userservice.getCurrentUserFromCookie();
    this.userrole = this.currentuser.role.name;
    console.log("We got the user role");
    if (this.userrole == "Authenticated" || this.userrole == "Administrator") {
          console.log("We are inside the Admin Role");
      this.clientservice.getClients()
        .subscribe(response => {
          console.log("we got a response");
          //console.log(response);
          this.clients = response;
         // this.isLoading = false;
                 });  
                   }
        else {
      window.alert("You have insufficient access. Please try again or contact the administration for assistance.");
    }
  }

//------------------------------------------------------------
//  SEARCH FEATURE FOR CLIENTS BY CRITERIA
//------------------------------------------------------------

  search(argument) {
    if (this.userrole == "Authenticated" || this.userrole == "Administrator") {
      this.clientservice.getClientByCriteria(this.querycriteria, argument).subscribe(res => {
        this.clients = res;
      });
    }
    else {
      window.alert("You have insufficient access. Please try again or contact the administration for assistance.");
    }
  }

//------------------------------------------------------------
//  EXPORT TO EXCEL FUNCTION
//------------------------------------------------------------
  exportexcel(): void
  {
    /* pass here the table id */
    let element = document.getElementById('excel-table');
    const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);
 
    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
 
    /* save to file */  
    XLSX.writeFile(wb, this.fileName);

  }
}
